'use client';

import { createContext } from 'react';

import type { ToastProviderContextInterface } from '../types/toast-provider-root.types';

const noop = () => {};

export const ToastProviderContext = createContext<ToastProviderContextInterface>({
  enqueueToast: noop,
  toasts: [],
  activeIds: [],
  pendingIds: [],
  pauseAll: noop,
  dismiss: noop,
  dismissAll: noop,
  pause: noop,
  resume: noop,
  resumeAll: noop,
});

ToastProviderContext.displayName = 'ToastProvider.Context';
